/* eslint-disable sort-keys */

export const ADMIN_TOP_NAV = {
  externalDashboard: {
    _id: 'externalDashboard',
    className: 'externalDashboard',
    functionKey: 'handleClickExternalDashboard',
    navTranslationKey: 'externalDashboardLabel',
    navTranslationRolloverKey: 'externalDashboardRollover',
    titleTranslationKey: 'externalDashboardTitle',
    urlPathname: '/externalDashboard',
    viewSelectionKey: 'EXTERNAL_DASHBOARD'
  },
  schools: {
    _id: 'schools',
    className: 'schools',
    functionKey: 'handleClickSchools',
    navTranslationKey: 'DashboardLabel',
    navTranslationRolloverKey: 'DashboardRollover',
    titleTranslationKey: 'DashboardTitle',
    urlPathname: '/',
    viewSelectionKey: 'DASHBOARD'
  },
  users: {
    _id: 'users',
    className: 'users',
    functionKey: 'handleClickUsers',
    navTranslationKey: 'UsersLabel',
    navTranslationRolloverKey: 'UsersRollover',
    titleTranslationKey: 'UsersTitle',
    urlPathname: '/users',
    viewSelectionKey: 'USERS'
  },
  products: {
    _id: 'products',
    className: 'products',
    functionKey: 'handleClickProducts',
    navTranslationKey: 'productsLabel',
    navTranslationRolloverKey: 'productsRollover',
    titleTranslationKey: 'productsTitle',
    urlPathname: '/products',
    viewSelectionKey: 'PRODUCTS'
  },
  libraryContent: {
    _id: 'libraryContent',
    className: 'content',
    functionKey: 'handleClickContent',
    navTranslationKey: 'contentLabel',
    navTranslationRolloverKey: 'contentRollover',
    titleTranslationKey: 'contentTitle',
    urlPathname: '/content',
    viewSelectionKey: 'CONTENT'
  },
  classrooms: {
    _id: 'classrooms',
    className: 'classes',
    functionKey: 'handleClickClassrooms',
    navTranslationKey: 'classesLabel',
    navTranslationRolloverKey: 'classesRollover',
    titleTranslationKey: 'classesTitle',
    urlPathname: '/classrooms',
    viewSelectionKey: 'CLASSROOMS'
  },
  testBuilder: {
    _id: 'testBuilder',
    className: 'library',
    functionKey: 'handleClickTestBuilder',
    navTranslationKey: 'testBuilderLabel',
    navTranslationRolloverKey: 'testBuilderRollover',
    titleTranslationKey: 'testBuilderTitle',
    urlPathname: '/adminTestbuilder',
    viewSelectionKey: 'TEST_BUILDER'
  },
  reports: {
    _id: 'reports',
    className: 'reports',
    functionKey: 'handleClickReports',
    navTranslationKey: 'ReportsLabel',
    navTranslationRolloverKey: 'ReportsRollover',
    titleTranslationKey: 'ReportsTitle',
    urlPathname: '/reports',
    viewSelectionKey: 'REPORTS'
  }
};

export const DISTRICT_ADMIN_TOP_NAV = ADMIN_TOP_NAV;

export const SCHOOL_ADMIN_TOP_NAV = ADMIN_TOP_NAV;

export const TEACHER_TOP_NAV = {
  externalDashboard: {
    _id: 'externalDashboard',
    className: 'externalDashboard',
    functionKey: 'showExternalDashboard',
    navTranslationKey: 'externalDashboardLabel',
    navTranslationRolloverKey: 'externalDashboardRollover',
    titleTranslationKey: 'externalDashboardTitle',
    urlPathname: '/externalDashboard',
    viewSelectionKey: 'EXTERNAL_DASHBOARD'
  },
  classrooms: {
    _id: 'classrooms',
    className: 'dashboard',
    functionKey: 'showClasses',
    navTranslationKey: 'DashboardLabel',
    navTranslationRolloverKey: 'DashboardRollover',
    titleTranslationKey: 'DashboardTitle',
    urlPathname: '/',
    viewSelectionKey: 'DASHBOARD'
  },
  libraryContent: {
    _id: 'libraryContent',
    className: 'content',
    functionKey: 'showContent',
    navTranslationKey: 'libraryContentLabel',
    navTranslationRolloverKey: 'libraryContentRollover',
    titleTranslationKey: 'libraryContentTitle',
    urlPathname: '/content',
    viewSelectionKey: 'CONTENT'
  },
  teacherProducts: {
    _id: 'teacherProducts',
    className: 'products',
    functionKey: 'showProducts',
    navTranslationKey: 'ProductLabel',
    navTranslationRolloverKey: 'ProductRollover',
    titleTranslationKey: 'ProductTitle',
    urlPathname: '/products',
    viewSelectionKey: 'PRODUCTS'
  },
  assignments: {
    _id: 'assignments',
    className: 'assignments',
    functionKey: 'showAssignments',
    navTranslationKey: 'AssignmentLabel',
    navTranslationRolloverKey: 'AssignmentRollover',
    titleTranslationKey: 'AssignmentTitle',
    urlPathname: '/assignments',
    viewSelectionKey: 'ASSIGNMENTS'
  },
  testBuilder: {
    _id: 'testBuilder',
    className: 'library',
    functionKey: 'handleClickTestBuilder',
    navTranslationKey: 'testBuilderLabel',
    navTranslationRolloverKey: 'testBuilderRollover',
    titleTranslationKey: 'testBuilderTitle',
    urlPathname: '/testbuilder',
    viewSelectionKey: 'TEST_BUILDER'
  },
  reports: {
    _id: 'reports',
    className: 'reports',
    functionKey: 'showReports',
    navTranslationKey: 'ReportLabel',
    navTranslationRolloverKey: 'ReportRollover',
    titleTranslationKey: 'ReportTitle',
    urlPathname: '/reports',
    viewSelectionKey: 'REPORTS'
  }
};

export const STUDENT_TOP_NAV = {
  externalDashboard: {
    _id: 'externalDashboard',
    className: 'externalDashboard',
    functionKey: 'showExternalDashboard',
    navTranslationKey: 'externalDashboardLabel',
    navTranslationRolloverKey: 'externalDashboardRollover',
    titleTranslationKey: 'externalDashboardTitle',
    urlPathname: '/externalDashboard',
    viewSelectionKey: 'EXTERNAL_DASHBOARD'
  },
  dashboard: {
    _id: 'dashboard',
    className: 'dashboard',
    functionKey: 'showDashboard',
    navTranslationKey: 'DashboardLabel',
    navTranslationRolloverKey: 'DashboardRollover',
    titleTranslationKey: 'DashboardTitle',
    urlPathname: '/',
    viewSelectionKey: 'DASHBOARD'
  },
  assignments: {
    _id: 'assignments',
    className: 'assignments',
    functionKey: 'showAssignments',
    navTranslationKey: 'AssignmentLabel',
    navTranslationRolloverKey: 'AssignmentRollover',
    titleTranslationKey: 'AssignmentTitle',
    urlPathname: '/student-assignments',
    viewSelectionKey: 'ASSIGNMENTS'
  },
  progress: {
    _id: 'progress',
    className: 'progress',
    functionKey: 'showProgress',
    navTranslationKey: 'ProgressLabel',
    navTranslationRolloverKey: 'ProgressRollover',
    titleTranslationKey: 'ProgressTitle',
    urlPathname: '/progress',
    viewSelectionKey: 'PROGRESS'
  },
  courses: {
    _id: 'courses',
    className: 'books',
    functionKey: 'showBook',
    navTranslationKey: 'BookLabel',
    navTranslationRolloverKey: 'BookRollover',
    titleTranslationKey: 'BookTitle',
    urlPathname: '/student-book-courses',
    viewSelectionKey: 'BOOK'
  },
  workspace: {
    _id: 'workspace',
    className: 'workspace',
    functionKey: 'showWorkspace',
    navTranslationKey: 'WorkspaceLabel',
    navTranslationRolloverKey: 'WorkspaceRollover',
    titleTranslationKey: 'WorkspaceTitle',
    urlPathname: '/workspace',
    viewSelectionKey: 'WORKSPACE'
  }
};

export const LTI_TOP_NAV = {
  ltiContentPicker: {
    _id: 'ltiContentPicker',
    className: 'lti-content-picker',
    functionKey: 'handleClickLtiContentPicker',
    navTranslationKey: 'ltiContentPickerLabel',
    navTranslationRolloverKey: 'ltiContentPickerRollover',
    titleTranslationKey: 'ltiContentPickerTitle',
    urlPathname: '/ltiContentPicker',
    viewSelectionKey: 'LTI_CONTENT_PICKER'
  },
  testBuilder: {
    _id: 'testBuilder',
    className: 'library',
    functionKey: 'handleClickTestBuilder',
    navTranslationKey: 'testBuilderLabel',
    navTranslationRolloverKey: 'testBuilderRollover',
    titleTranslationKey: 'testBuilderTitle',
    urlPathname: '/testbuilder',
    viewSelectionKey: 'TEST_BUILDER'
  },
  reports: {
    _id: 'reports',
    className: 'reports',
    functionKey: 'handleClickReports',
    navTranslationKey: 'ReportLabel',
    navTranslationRolloverKey: 'ReportRollover',
    titleTranslationKey: 'ReportTitle',
    urlPathname: '/reports',
    viewSelectionKey: 'REPORTS'
  }
};

export const DEFAULT_ADMIN_TOP_NAV_ORDER_ARRAY = [
  'schools', 'users', 'products', 'libraryContent', 'classrooms', 'testBuilder', 'reports'
];
export const DEFAULT_DISTRICT_ADMIN_TOP_NAV_ORDER_ARRAY = (
  DEFAULT_ADMIN_TOP_NAV_ORDER_ARRAY
);
export const DEFAULT_SCHOOL_ADMIN_TOP_NAV_ORDER_ARRAY = (
  DEFAULT_ADMIN_TOP_NAV_ORDER_ARRAY
);
export const DEFAULT_TEACHER_TOP_NAV_ORDER_ARRAY = [
  'classrooms', 'libraryContent', 'teacherProducts', 'assignments', 'testBuilder', 'reports'
];
export const DEFAULT_STUDENT_TOP_NAV_ORDER_ARRAY = [
  'dashboard', 'assignments', 'progress', 'courses', 'workspace'
];
export const DEFAULT_LTI_TOP_NAV_ORDER_ARRAY = [
  'ltiContentPicker',
  /* 'testBuilder', */ // TODO: testBuilder for LTI is currently unsupported until DEMO-3042 is implemented
  'reports'
];

export const TOP_NAV_NAME = {
  TopNav: 'TopNav',
  AdminTopNav: 'AdminTopNav',
  GenericTopNav: 'GenericTopNav',
  LtiTopNav: 'LtiTopNav',
  StudentTopNav: 'StudentTopNav'
};
